(function () {
	const initCollectionSliders = () => {
		$(".collection-grid").each(function () {
			if ($(this).hasClass("slider_started")) {
				return;
			}
			$(this).addClass("slider_started");
			const id = $(this).data("id");
			const autoplay = $(this).data("autoplay");
			const delay = $(this).data("delay") * 1000;
			const perRow = $(this).data("per_row");
			// "Mobile: show 2 events per row" section setting (Events Carousel only
			// for now). jQuery parses the data-mobile-columns="true"/"false" string
			// into a boolean; when the attribute is absent (e.g. Collection Carousel,
			// which doesn't render it) this reads undefined, so mobileColumns stays
			// false and the base slidesPerView is unchanged at 1 — existing sections
			// keep their current mobile behaviour with no opt-in required.
			const mobileColumns = $(this).data("mobile-columns");
			const mobileBaseSlidesPerView = mobileColumns === true ? 2 : 1;

			let swiperParams = {
				speed: $(this).data("speed") * 1000,
				slidesPerView: mobileBaseSlidesPerView,
				spaceBetween: 16,
				loop: false,
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				breakpoints: {
					750: {
						slidesPerView: perRow >= 2 ? 2 : 1,
					},
					1150: {
						slidesPerView: perRow,
					},
				},
			};

			if (autoplay) {
				swiperParams.autoplay = {
					delay: delay,
					pauseOnMouseEnter: true,
					disableOnInteraction: false,
				};
			}

			new Swiper(`#${id} .swiper`, swiperParams);
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		initCollectionSliders();
		document.addEventListener("shopify:section:load", function () {
			initCollectionSliders();
		});
	});
})();
